export default __webpack_public_path__ + "static/media/aadf93c13b27518e.493ad5cc19bb413dfaaae8781486cefc.svg";